export default {
  'Home.AccountCodeLogin': '账号验证码登录',
  'Home.Pleaseenteryourphonenumberoremail': '请输入手机或邮箱',
  'Home.Pleaseenteryouraccount': '请输入账号',
  'Home.PleaseenteryourphonenumberoremailSure': '请输入正确的手机或邮箱',
  'Home.Pleaseentertheverificationcode': '请输入验证码',
  'Home.PleaseentertheverificationcodeSure': '请输入正确的验证码',
  'Home.PleaseCode': '请完成验证',
  'Home.GetVerificationCode': '获取',
  'Home.Login&Register': '登录 & 注册',
  'Home.AccountPasswordLogin': '账号密码登录',
  'Home.Pleaseenteryourpassword': '请输入密码',
  'Home.Login': '登录',
  'Home.Profile': '个人资料',
  'Home.BasicInformation': '基础信息',
  'Home.AccountManagement': '账号管理',
  'Home.PhoneSettings': '手机设置',
  'Home.EmailSettings': '邮箱设置',
  'Home.ChangePassword': '修改密码',
  'Home.UserLogout': '用户注销',
  'Home.PhoneAccount': '手机账号',
  'Home.EmailAccount': '邮箱账号',
  'Home.RealName': '姓名',
  'Home.Save': '保存',
  'Home.SecurityAuthentication': '安全认证',
  'Home.BindNewPhoneNumber': '绑定新手机号',
  'Home.SendTip1': '给手机号{phone}发送验证码，进行身份验证',
  'Home.Next': '下一步',
  'Home.SendTip2': '给邮箱{email}发送验证码，进行身份验证',
  'Home.BindNewEmail': '绑定新邮箱',
  'Home.SetNewPassword': '设置新密码',
  'Home.LogoutConfirmation': '确认注销',
  'Home.Logout': '退出登录',

  'Home.Nosettings': '暂无设置',
  'Home.Pleaseenteryourrealname': '请输入名称',
  'Home.Modifiedsuccessfully': '修改成功',
  'Home.Binding': '绑定',
  'Home.Pleaseenteryourphonenumber': '请输入手机号',
  'Home.PleaseenteryourphonenumberSure': '请输入正确的手机号',
  'Home.PhoneTip1': '您暂未绑定手机，请填写手机号进行绑定',
  'Home.PhoneTip2': '手机号已被绑定，请检查',
  'Home.PhoneNumber': '手机号',
  'Home.Email': '邮箱',
  'Home.Confirmmodifications': '确定修改',
  'Home.Securityverification': '安全验证',
  'Home.Bind1': '绑定新手机号',
  'Home.EmailTip1': '邮箱已被绑定，请检查',
  'Home.EmailTip2': '您暂未绑定邮箱，请填写邮箱进行绑定',
  'Home.EmailTip3': '请输入邮箱',
  'Home.EmailTip4': '请输入正确的邮箱',

  'Home.Password': '密码',
  'Home.PasswordTip1': '密码格式为8-16位字母/数字/符号任2种',
  'Home.PasswordTip2': '请输入密码,8-16位字母/数字/符号任2种',
  'Home.Confirmpassword': '确认密码',
  'Home.PasswordTip3': '请再次输入密码',
  'Home.PasswordTip4': '两次密码不一致',

  'Home.Tip1': '请注意！注销后数据无法恢复',
  'Home.Tip2': '确定注销',
  userAccountVerifyRules: '名称长度支持 1-64位字符,不能以空格字符开头或结尾',
  'Home.PasswordError10Times':
    '密码错误次数较多，请联系上级经销商重置密码；或者通过验证码登录，并且在登录后修改密码！',

  'Home.oldPasswordToNew': '旧密码修改新密码',
  'Home.codeToNew': '验证码修改新密码',
  'Home.Pleaseentertheoldpassword': '请输入旧密码',
  'Home.Pleaseenterthenewpassword': '请输入新密码',
  'Home.PleaseenterthenewpasswordSure': '请输入正确的密码',
  'Home.Pleaseenterthenewpasswordagain': '请再次输入新密码',
  'Home.PleaseenterthenewpasswordagainSure': '两次密码不一致',
  'Home.WeakPasswordTip': '密码至少包含字母与数字，且不少于8位',
  'Home.oldPassword': '旧密码',
  'Home.newPassword': '新密码',
  'Home.confirmPassword': '确认密码',
  'Home.UpdateSuccess': '密码修改成功',
  'Home.PasswordError': '账号或密码错误',
  'Home.ConfirmRequired': '请输入确认密码',

  'Home.oldPasswordToLogOut': '旧密码注销',
  'Home.CodeToLogOut': '验证码注销',
  'Login.Agree': '阅读并同意我们的',
  'Login.AgreeError': '请先同意协议',
};
